import { Rect } from '@st/geom'

// The full scrollable area and the visible viewport window, both in a shared
// coordinate space with the scroll area origin at (0, 0).
export type ScrollGeometry = {
  scrollAreaRect: Rect
  viewportRect: Rect
}

export function getScrollGeometry(scrollElement: HTMLElement): ScrollGeometry {
  const viewportDOMRect = scrollElement.getBoundingClientRect()

  const scrollAreaRect: Rect = {
    x: viewportDOMRect.x - scrollElement.scrollLeft,
    y: viewportDOMRect.y - scrollElement.scrollTop,
    width: scrollElement.scrollWidth,
    height: scrollElement.scrollHeight
  }

  const viewportRect: Rect = {
    x: viewportDOMRect.x,
    y: viewportDOMRect.y,
    width: scrollElement.clientWidth,
    height: scrollElement.clientHeight
  }

  return moveOriginToZero({
    viewportRect: viewportRect,
    scrollAreaRect: scrollAreaRect
  })
}

// Normalize so viewportRect.x/y equals scrollLeft/scrollTop — the coordinate
// system page rects are laid out in.
function moveOriginToZero(scrollGeometry: ScrollGeometry): ScrollGeometry {
  return {
    scrollAreaRect: {
      x: 0,
      y: 0,
      width: scrollGeometry.scrollAreaRect.width,
      height: scrollGeometry.scrollAreaRect.height
    },
    viewportRect: {
      x: scrollGeometry.viewportRect.x - scrollGeometry.scrollAreaRect.x,
      y: scrollGeometry.viewportRect.y - scrollGeometry.scrollAreaRect.y,
      width: scrollGeometry.viewportRect.width,
      height: scrollGeometry.viewportRect.height
    }
  }
}
